import React, { useContext } from 'react';
import {
  DrawerBody,
  Skeleton,
  SkeletonBlock,
  SkeletonContent,
  SkeletonLine
} from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AddToContext } from '../../AddToContext';
import { PreviouslyPurchasedPlaceholder } from '../previously-purchased/PreviouslyPurchasedPlaceholder';

export const AddToLoading = () => {
  const { customer } = useContext(ExperienceContext);
  const isB2B = customer?.type === 'b2b';

  const { defaultOpen } = useContext(AddToContext);
  const shouldShowAddMaterialsPlaceholder = isB2B && defaultOpen;

  if (shouldShowAddMaterialsPlaceholder) {
    return (
      <Skeleton grow disablePadding="y" orientation="vertical">
        <SkeletonContent>
          <SkeletonBlock height={8} />
          <SkeletonLine variant="heading" />
        </SkeletonContent>
        <PreviouslyPurchasedPlaceholder />
      </Skeleton>
    );
  }

  return (
    <>
      <DrawerBody>
        <Skeleton disablePadding="y" orientation="horizontal">
          <SkeletonBlock />
          <SkeletonLine />
        </Skeleton>
      </DrawerBody>
    </>
  );
};